// TODO: delete with the last remote menu confirm, https://github.com/combinaut/sparkle/issues/32365
// Asks before a jquery-ujs remote form sends. Only callers: remote `Admin::SpMenu::Items::FormItem`s
// with `confirm:`. Nothing but `entrypoints/admin_legacy.js` may import it.
import { requestConfirmation } from "#ce/components/SpConfirm/request-confirmation";
import { t, whenComponentsI18nReady } from "#ce/shared/components-i18n";

const CONFIRMED_FORM = 'form[data-remote][data-behaviour~="with-confirmation"]';
const confirmedForms = new WeakSet();
const pendingForms = new WeakSet();

async function askConfirmation(form) {
  await whenComponentsI18nReady;

  return requestConfirmation({
    title: t("action_form_confirm_title"),
    content: form.dataset.confirmationMessage,
    confirmLabel: t("action_form_confirm"),
    cancelLabel: t("action_form_cancel"),
  });
}

function sendConfirmedForm(form, submitter) {
  if (!form.isConnected || (submitter && submitter.form !== form)) {
    return;
  }

  confirmedForms.add(form);

  try {
    form.requestSubmit(submitter || undefined);
  } finally {
    confirmedForms.delete(form);
  }
}

async function confirmThenSend(form, submitter) {
  pendingForms.add(form);

  try {
    if (await askConfirmation(form)) {
      sendConfirmedForm(form, submitter);
    }
  } finally {
    pendingForms.delete(form);
  }
}

function confirmRemoteSubmit(event) {
  const form = event.target;

  if (!form.matches?.(CONFIRMED_FORM) || confirmedForms.has(form)) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  if (!pendingForms.has(form)) {
    void confirmThenSend(form, event.submitter);
  }
}

document.addEventListener("submit", confirmRemoteSubmit, true);
